import { DialogTitle, DialogTitleProps, IconButton, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        hyphens: 'auto',
    },
}));

interface DialogTitleWithCloseProps extends DialogTitleProps {
    onClose: () => void;
}

const DialogTitleWithClose: React.FC<DialogTitleWithCloseProps> = ({ children, onClose, ...rest }) => {
    const classes = useStyles();

    return (
        <DialogTitle disableTypography className={classes.root} {...rest}>
            <Typography variant="h6">{children}</Typography>
            {onClose && (
                <div>
                    <IconButton size="small" aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            )}
        </DialogTitle>
    );
};

export default DialogTitleWithClose;
